import React from "react";
import "./Simulazione.scss";
import GameSelector from "../Panels/GameSelector.mjs";
import LoadingPanel from "../Panels/LoadingPanel.mjs";
// import Cruscotto from "../Cruscotto/index.tsx";
import {TabContent, TabPane} from "reactstrap";
import Backstage from "../Backstage/Backstage.mjs";
import UserInfo from "../UserInfo/UserInfo.mjs";
import ScriptBook from "../ScriptBook/ScriptBook.mjs";
import UserList from "../UserList/UserList.mjs";
import appLib from "../../libs/appLib.mjs";
import Dashboard from "../Dashboard/Dashboard.mjs";

const G = window.glob;

const Simulazione = class extends React.Component {
	constructor(props) {
		super(props);
		const mo = G.getStatus("mainOperation");
		this.state = {
			tab: mo?.params?.tab ?? "Game",
			gamechosen: G.getStatus("GameChosen"),
			gamedata: G.getStatus("Game"),
			admin: !!G.getStatus("Player")?.admin,
			scenario: G.getStatus("Scenario")
		};
		this.uid = G.generateUid("Simulazione");
		this.renderContent = this.renderContent.bind(this);
		this.canPlay = this.canPlay.bind(this);
	}

	componentDidMount() {
		G.register("mainOperation",(mo) => {
			const tab = mo?.params?.tab ?? "Game";
			this.setState({tab: tab });
			appLib.setPlayerStatus(tab,"currentTab");
		},this.uid);
		G.register("Player",(p) => {
			this.setState({admin: !!p?.admin});
			this.canPlay()
		},this.uid);
		G.register("Game",(g) => {
			this.setState({gamedata: g});
			this.canPlay()
		}, this.uid);
		G.register("GameChosen",(g) => {
			this.setState({gamechosen: g});
			this.canPlay()
		},this.uid);
		G.register("Scenario",(s) => {
			this.setState({scenario: s}, this.canPlay );
		},this.uid);
		G.register("Copione",() => {
			this.canPlay()
		},this.uid);
		G.register("Players",() => {
			this.canPlay()
		},this.uid);
		this.canPlay();
	}

	componentWillUnmount() {
		G.deregister(this.uid);
	}
	canPlay() {
		let r = true;
		if ( r ) if ( ! G.getStatus('Player') ) r = false;
		if ( r ) if ( ! G.getStatus('Game') ) r = false;
		if ( r ) if ( ! G.getStatus('GameStatus') ) r = false;
		if ( r ) if ( ! G.getStatus('Scenario') ) r = false;
		if ( r ) if ( ! G.getStatus('Players') ) r = false;
		if ( r ) if ( ! G.getStatus('Copione') ) r = false;
		this.setState({ canPlay: r });
		return r;
	}
	renderContent() {
		if (!this.state.gamechosen) return <div className={"Simulazione"}><GameSelector /></div>;
		if ( this.state.canPlay ) return <Dashboard/>;
		return <div className={"Simulazione"}><LoadingPanel/></div>;
	}

	render() {
		return (
			<TabContent activeTab={this.state.tab}>
				<TabPane tabId={"Dashboard"} className={"animate__animated animate__fadeIn"}>
					{this.renderContent()}
				</TabPane>
				{ this.state.admin && (
					<>
						<TabPane tabId={"Backstage"} className={"animate__animated animate__fadeIn"}>
							<Backstage/>
						</TabPane>
						<TabPane tabId={"UserList"} className={"animate__animated animate__fadeIn"}>
							{ this.state.tab === 'UserList' && <UserList /> }
						</TabPane>
						<TabPane tabId={"ScriptBook"} className={"animate__animated animate__fadeIn"}>
							{ this.state.tab === 'ScriptBook' && <ScriptBook /> }
						</TabPane>
					</>
				)}
				<TabPane tabId={"UserInfo"} className={"animate__animated animate__fadeIn"}>
					<UserInfo/>
				</TabPane>
			</TabContent>
		);
	}
};

export default Simulazione;
